import React, {Fragment, useContext, useEffect, useState} from "react";
import MenuForm, {MenuFormItem} from "../../components/forms/menuForm";
import {
    AutomatedCampaignType,
    CampaignBigType,
    CampaignModel,
    CampaignStatus,
    CampaignSummary,
    CampaignType,
} from "./dataForActiveCampaign";
import {useHistory} from "react-router-dom";
import {RoutePath} from "../../router/routePath";
import {changeAutoCampaignStatus, changeRegularCampaignStatus, getCampaignList} from "./campaignService";
import {ProviderContext} from "../providerContext";
import EmptyCampaign from "./emptyCampaign";
import {ApiCampaign} from "../../util/http/API";
import {getFile} from "../../util/http/HTTP";
import {PromptContext} from "../promptContext";
// import PageButton from "../../components/pageButton/pageButton";
import {CampaignListType} from "./campaign";
import Spinner from "../../components/spinner/spinner";
import {ActionType, PresentationStyle} from "../../util/enum";
import CustomModal from "../../components/modal/customModal";
import PreviewCampaign from "./previewCampaign";
import {GraylogContext} from "../graylogContext";
import {GrayLog} from "../../grayLog/grayLog";
import {LogEventName} from "../../grayLog/logKey";
import {$arrowDown, $arrowUp} from "../../assets/icons";
import CampaignStatisticList from "./campaignStatisticList";

// export const MaxAutoCampaignsCount = 3
export const MaxAppointmentReminderCount = 3
export const MaxBirthdayReminderCount = 3
export const MaxActiveCampaignsCount = 20

const pageSize = MaxActiveCampaignsCount

interface IProps {
    campaignListType: CampaignListType,
    onNewCampaign: (type: AutomatedCampaignType) => void,
    onUpdateCampaignCount: (count: number) => void
}

enum CampaignMenuActionType {
    viewDetail,
    edit,
    pause,
    resume,
    export,
    cancel,
}

export default function CampaignList(props: IProps) {
    const {campaignListType, onNewCampaign, onUpdateCampaignCount} = props
    const history = useHistory()
    // const [total, setTotal] = useState(0)
    // const [page, setPage] = useState(1)
    const page = 1
    const [isNoActiveRecord, setIsNoActiveRecord] = useState<boolean>(false)
    const [dataSource, setDataSource] = useState<Array<CampaignModel>>([])
    const [isShowSpinner, setIsShowSpinner] = useState<boolean>(false)
    const provider = useContext(ProviderContext)
    const {showError, showAlert} = useContext(PromptContext)
    const logEmployee = useContext(GraylogContext)
    const [showCampaignPreviewModal, setShowCampaignPreviewModal] = useState<boolean>(false)
    const [showCampaignStatisticModal, setShowCampaignStatisticModal] = useState<boolean>(false)
    const [selectedCampaign, setSelectedCampaign] = useState<CampaignModel>()
    const [isAppointmentSectionCollapsed, setIsAppointmentSectionCollapsed] = useState<boolean>(false)
    const [isBirthdaySectionCollapsed, setIsBirthdaySectionCollapsed] = useState<boolean>(false)
    const [isOtherSectionCollapsed, setIsOtherSectionCollapsed] = useState<boolean>(false)

    useEffect(() => {
        getCampaignListByPage()
    }, [page, campaignListType, provider])

    const getCampaignListByPage = () => {
        setIsShowSpinner(true)
        getCampaignList(provider.mEmployeeID, campaignListType, page, pageSize, (list, total) => {
            setIsShowSpinner(false)
            setDataSource(list)
            // setTotal(total)
            campaignListType === CampaignListType.active && onUpdateCampaignCount && onUpdateCampaignCount(total)
            page === 1 && setIsNoActiveRecord(!list.length)
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }, (error) => {
            setIsShowSpinner(false)
            showError(error)
        })
    }

    const $campaignNameRow = ({summary}: CampaignModel) => {
        const {name, sendDateTime} = summary
        return (
            <div className={"max-w-max"}>
                <p className={"text-sm text-gray-1"}>{name}</p>
                <p className={"text-sm text-black-54 mt-1"}>{sendDateTime}</p>
            </div>
        )
    }

    const $getStatusName = (status: CampaignStatus): [string, string, string] => {
        if (status === CampaignStatus.scheduled) {
            return ["Scheduled", "text-purple-1", "bg-purple-1-15"]
        } else if (status === CampaignStatus.failed) {
            return ["Failed", "text-red", "bg-red-15"]
        } else if (status === CampaignStatus.inProgress) {
            return ["In Progress", "text-green", "bg-green-15"]
        } else if (status === CampaignStatus.completed) {
            return ["Completed", "text-blue", "bg-blue-15"]
        } else if (status === CampaignStatus.paused) {
            return ["Paused", "text-gray-2", "bg-black-10"]
        } else if (status === CampaignStatus.canceled) {
            return ["Canceled", "text-red", "bg-red-15"]
        }
        return ["", "", ""]
    }

    const $statusRow = ({summary}: CampaignModel) => {
        const {status} = summary
        const [name, statusTextColor, statusTextBgColor] = $getStatusName(status)
        return (
            <div className={`py-1 px-1.5 rounded ${statusTextBgColor} max-w-max`}>
                <p className={`text-xs font-semibold ${statusTextColor} max-w-max`}>{name}</p>
            </div>
        )
    }

    const $recurringCampaignIcon = (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_465_1750)">
                <path d="M9.35525 3.62985C8.62255 2.94379 7.67169 2.56771 6.66294 2.5686C4.84752 2.5702 3.28025 3.81496 2.84753 5.54165C2.81603 5.66735 2.70404 5.7561 2.57446 5.7561H1.23142C1.05568 5.7561 0.922184 5.59656 0.954691 5.42385C1.46181 2.73088 3.82618 0.693604 6.6665 0.693604C8.22388 0.693604 9.63817 1.30617 10.6817 2.30341L11.5188 1.46634C11.8731 1.11199 12.479 1.36296 12.479 1.8641V5.0061C12.479 5.31677 12.2272 5.5686 11.9165 5.5686H8.7745C8.27336 5.5686 8.02239 4.96272 8.37674 4.60835L9.35525 3.62985ZM1.4165 7.4436H4.55851C5.05965 7.4436 5.31062 8.04949 4.95627 8.40386L3.97775 9.38238C4.71046 10.0685 5.66139 10.4445 6.67016 10.4436C8.48464 10.442 10.0525 9.19806 10.4855 7.4706C10.517 7.34491 10.629 7.25615 10.7586 7.25615H12.1016C12.2773 7.25615 12.4108 7.41569 12.3783 7.5884C11.8712 10.2813 9.50682 12.3186 6.6665 12.3186C5.10913 12.3186 3.69484 11.706 2.65131 10.7088L1.81424 11.5459C1.45989 11.9002 0.854004 11.6493 0.854004 11.1481V8.0061C0.854004 7.69544 1.10584 7.4436 1.4165 7.4436Z" fill="black" fillOpacity="0.54"/>
            </g>
            <defs>
                <clipPath id="clip0_465_1750">
                    <rect width="12" height="12" fill="white" transform="translate(0.666504 0.506104)"/>
                </clipPath>
            </defs>
        </svg>
    )
    const $typeRow = ({summary}: CampaignModel) => {
        const {type, campaignBigType, campaignType} = summary
        return <div className={"flex flex-row items-center space-x-2"}>
            <p className={"text-gray-1 text-sm font-normal"}>{type}</p>
            {campaignBigType === CampaignBigType.automatedCampaign || campaignType !== CampaignType.sendOnce ? $recurringCampaignIcon : null}
        </div>
    }

    const $patientGroupRow = ({summary}: CampaignModel) => {
        const {groupName, patientCount, campaignBigType} = summary
        if (campaignBigType === CampaignBigType.automatedCampaign) {
            return null
        }
        return <div className={"flex flex-col items-start justify-center"}>
            <p className={"text-sm text-gray-1 text-left"}>{groupName}</p>
            <p className={"inline-block text-sm text-black-54 mt-1 text-left"}>
                {`${patientCount} ${patientCount > 1 ? "Patients" : "Patient"}`}</p>
        </div>
    }

    const $createByRow = ({summary}: CampaignModel) => {
        return <p className={"text-gray-1 text-sm font-normal "}>{summary.createdBy}</p>
    }

    const $statisticsRow = (campaign: CampaignModel) => {
        const {summary} = campaign
        const {sendSuccessCount, patientCount, campaignBigType} = summary
        const successRate = patientCount ? ((sendSuccessCount / patientCount) * 100).toFixed(sendSuccessCount === patientCount ? 0 : 1) : "--"
        return <div className={"flex flex-col items-start justify-center"}>
            <p className={"flex flex-row items-center text-sm text-gray-1 text-center"}>
                <span onClick={() => {
                    onViewCampaignDetail(campaign)
                }} className={"cursor-pointer mr-1 text-blue-1 font-semibold"}>{sendSuccessCount}</span>
                Delivered</p>
            {campaignBigType !== CampaignBigType.automatedCampaign ? <p className={"text-sm  text-black-54 mt-1 text-center"}>({successRate})%</p> : null }
        </div>
    }

    const exportCampaignStatistic = ({summary}: CampaignModel) => {
        const {id, relationId, name, sendDateTime, campaignBigType}: CampaignSummary = summary
        const fileName = `${name}-${sendDateTime}.csv`
        if (campaignBigType === CampaignBigType.regularCampaign) {
            const param = {
                fileType: 1,
                campaignId: id,
            }
            getFile(ApiCampaign.getFileByCampaign, fileName, param)
        } else if (campaignBigType === CampaignBigType.automatedCampaign) {
            const param = {
                fileType: 1,
                relationId: relationId,
            }
            getFile(ApiCampaign.getFileByAutoCampaign, fileName, param)
        }
    }

    const onEditCampaignSetting = ({summary}: CampaignModel) => {
        history.push({
            pathname: RoutePath.newCampaign,
            search: `?campaignId=${summary.id}&actionType=${ActionType.edit}`,
        })
    }

    const onViewCampaignSetting = (campaign: CampaignModel) => {
        setSelectedCampaign(campaign)
        setShowCampaignPreviewModal(true)
    }

    const onViewCampaignDetail = (campaign: CampaignModel) => {
        setSelectedCampaign(campaign)
        setShowCampaignStatisticModal(true)
    }

    const onCancelCampaign = ({summary}: CampaignModel) => {
        const updateCampaignStatus = (summary: CampaignSummary) => {
            const {campaignBigType, status} = summary
            if (campaignBigType === CampaignBigType.automatedCampaign) {
                onChangeAutoCampaignStatus(summary, CampaignStatus.canceled)
            } else if (campaignBigType === CampaignBigType.regularCampaign && status === CampaignStatus.scheduled) {
                onChangeRegularCampaignStatus(summary, CampaignStatus.canceled)
            }
        }

        showAlert(
            "Cancel Scheduled Campaign",
            "Cancel this scheduled campaign? This action cannot be reversed.",
            {title: "Confirm Cancel Campaign", onClick: () => {
                updateCampaignStatus(summary)
            }},
            {title: "Cancel", onClick: undefined}
        )
    }

    const onPauseCampaign = ({summary}: CampaignModel) => {
        onChangeAutoCampaignStatus(summary, CampaignStatus.paused)
    }

    const onResumeCampaign = ({summary}: CampaignModel) => {
        onChangeAutoCampaignStatus(summary, CampaignStatus.inProgress)
    }

    const onChangeAutoCampaignStatus = (summary: CampaignSummary, status: CampaignStatus) => {
        const { id, relationId, campaignBigType} = summary

        let eventName = ""
        if (status === CampaignStatus.canceled) {
            eventName = LogEventName.cancelCampaign
        } else if (status === CampaignStatus.paused) {
            eventName = LogEventName.pauseCampaign
        } else if (status === CampaignStatus.inProgress) {
            eventName = LogEventName.resumeCampaign
        }

        setIsShowSpinner(true)
        changeAutoCampaignStatus(id, relationId, status, () => {
            setIsShowSpinner(false)
            getCampaignListByPage()
            eventName && GrayLog.event(eventName, {isSuccessful: true, campaignType: campaignBigType, ...logEmployee})
        }, (error) => {
            setIsShowSpinner(false)
            showError(error)
            const errMsg = `${error.code} - ${error.msg}`
            eventName && GrayLog.event(eventName, {isSuccessful: false, errMsg: errMsg, campaignType: campaignBigType, ...logEmployee})
        })
    }

    const onChangeRegularCampaignStatus = (summary: CampaignSummary, status: CampaignStatus) => {
        const { id, campaignBigType} = summary
        setIsShowSpinner(true)
        changeRegularCampaignStatus(id, status, () => {
            setIsShowSpinner(false)
            getCampaignListByPage()
            GrayLog.event(LogEventName.cancelCampaign, {isSuccessful: true, campaignType: campaignBigType, ...logEmployee})
        }, (error) => {
            setIsShowSpinner(false)
            showError(error)
            const errMsg = `${error.code} - ${error.msg}`
            GrayLog.event(LogEventName.cancelCampaign, {isSuccessful: false, errMsg: errMsg, campaignType: campaignBigType, ...logEmployee})
        })
    }

    const onMenuClick = (id: any, campaign: CampaignModel) => {
        if (id === CampaignMenuActionType.viewDetail) {
            onViewCampaignSetting(campaign)
        } else if (id === CampaignMenuActionType.edit) {
            onEditCampaignSetting(campaign)
        } else if (id === CampaignMenuActionType.export) {
            exportCampaignStatistic(campaign)
        } else if (id === CampaignMenuActionType.cancel) {
            onCancelCampaign(campaign)
        } else if (id === CampaignMenuActionType.pause) {
            onPauseCampaign(campaign)
        } else if (id === CampaignMenuActionType.resume) {
            onResumeCampaign(campaign)
        }
    }
    const $menuRow = (campaign: CampaignModel) => {
        const {summary} = campaign
        // scheduled and not recurrence regular campaign can be edit.
        let dataForMenuForm: Array<MenuFormItem> = [{name: "View Details", id: CampaignMenuActionType.viewDetail}, {name: "Export", id: CampaignMenuActionType.export}]
        if (summary.campaignBigType === CampaignBigType.regularCampaign && summary.status === CampaignStatus.scheduled) {
            if (summary.campaignType === CampaignType.sendOnce) {
                dataForMenuForm = [
                    {name: "View Details", id: CampaignMenuActionType.viewDetail},
                    {name: "Edit", id: CampaignMenuActionType.edit},
                    {name: "Cancel", id: CampaignMenuActionType.cancel},
                    {name: "Export", id: CampaignMenuActionType.export},
                ]
            } else {
                dataForMenuForm = [
                    {name: "View Details", id: CampaignMenuActionType.viewDetail},
                    {name: "Cancel", id: CampaignMenuActionType.cancel},
                    {name: "Export", id: CampaignMenuActionType.export},
                ]
            }
        } else if (summary.campaignBigType === CampaignBigType.automatedCampaign) {
            if (summary.status === CampaignStatus.paused) {
                dataForMenuForm = [
                    {name: "View Details", id: CampaignMenuActionType.viewDetail},
                    {name: "Edit", id: CampaignMenuActionType.edit},
                    {name: "Resume", id: CampaignMenuActionType.resume},
                    {name: "Export", id: CampaignMenuActionType.export},
                ]
            } else {
                dataForMenuForm = [
                    {name: "View Details", id: CampaignMenuActionType.viewDetail},
                    {name: "Edit", id: CampaignMenuActionType.edit},
                    {name: "Pause", id: CampaignMenuActionType.pause},
                    {name: "Export", id: CampaignMenuActionType.export},
                ]
            }

            if (!summary.sendSuccessCount) {
                dataForMenuForm = dataForMenuForm.filter((item) => item.id !== CampaignMenuActionType.export)
            }
        }
        return (
            <MenuForm data={dataForMenuForm} onClick={(id) => {
                onMenuClick(id, campaign)
            }} >
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 14.5229C16.8954 14.5229 16 13.6275 16 12.5229C16 11.4184 16.8954 10.5229 18 10.5229C19.1046 10.5229 20 11.4184 20 12.5229C20 13.0534 19.7893 13.5621 19.4142 13.9372C19.0391 14.3122 18.5304 14.5229 18 14.5229ZM12 14.5229C10.8954 14.5229 10 13.6275 10 12.5229C10 11.4184 10.8954 10.5229 12 10.5229C13.1046 10.5229 14 11.4184 14 12.5229C14 13.0534 13.7893 13.5621 13.4142 13.9372C13.0391 14.3122 12.5304 14.5229 12 14.5229ZM6 14.5229C4.89543 14.5229 4 13.6275 4 12.5229C4 11.4184 4.89543 10.5229 6 10.5229C7.10457 10.5229 8 11.4184 8 12.5229C8 13.0534 7.78929 13.5621 7.41421 13.9372C7.03914 14.3122 6.53043 14.5229 6 14.5229Z" fill="#2F80ED"/>
                </svg>
            </MenuForm>
        )
    }

    // const startPageNumber = ((page - 1) * pageSize + 1)
    // const endPageNumber = (page) * pageSize >= total ? total : (page) * pageSize
    // const pageRange = `${startPageNumber}-${endPageNumber}`
    // const $pageIndex = total > 0 ? (
    //     <div className={"flex flex-row items-center text-sm text-gray-1 space-x-2"}>
    //         <span className={"text-black font-bold"}>{pageRange}</span>
    //         <span className={"text-gray-2"}>of</span>
    //         <span className={"text-gray-3"}>{total}</span>
    //     </div>) : null

    // const onNextPage = () => {
    //     if (page * pageSize > total) {
    //         return
    //     }
    //     setPage(page + 1)
    //
    // }
    // const onPreviousPage = () => {
    //     if (page > 1) {
    //         setPage(page - 1)
    //     }
    // }
    //
    // const hasPreviousPage = (page > 1)
    // const hasNextPage = !(page * pageSize > total)
    // const $pageButton = (
    //     <div className={"flex flex-row items-center justify-center space-x-4"}>
    //         <PageButton enable={hasPreviousPage} rotate={"rotate-180"} onClick={onPreviousPage} />
    //         <PageButton enable={hasNextPage} onClick={onNextPage} />
    //     </div>
    // )

    // const $tableFooter = !isNoActiveRecord ? (
    //     <div className={"flex flex-row items-center justify-end w-full pt-4 space-x-20"}>
    //         {$pageIndex}
    //         {$pageButton}
    //     </div>
    // ) : null

    const $tableSectionHeader = (title: string, count: number, isCollapsed: boolean, toggleCollapseStatus: () => void) => {
        if (!count) {
            return null
        }
        return (
            <tr className={"border-b border-border-black-12"} key={title}>
                <td className={"py-3"}>
                    <div className={"flex flex-row items-center"}>
                        <p className={"text-sm text-gray-1 font-bold"}>{title}</p>
                        <div className={"py-0.5 px-2.5 ml-2 rounded-xl bg-primary"}>
                            <p className={"text-xs text-white font-semibold"}>{count}</p>
                        </div>
                    </div>
                </td>
                <td className={"py-3"}/>
                <td className={"py-3"}/>
                <td className={"py-3"}/>
                <td className={"py-3"}/>
                <td className={"py-3"}/>
                <td className={"py-3"}>
                    <button className={"flex flex-row items-center p-1"} onClick={toggleCollapseStatus}>
                        {isCollapsed ? $arrowDown : $arrowUp}
                    </button>
                </td>
            </tr>
        )
    }

    const $tableRowsFor = (ds: Array<CampaignModel>) => {
        return ds.map((campaign, idx) => {
            return (
                <tr className={"border-b border-border-black-12"} key={idx}>
                    <td className={"py-3"}>{$campaignNameRow(campaign)}</td>
                    <td className={"py-3"}>{$statusRow(campaign)}</td>
                    <td className={"py-3"}>{$typeRow(campaign)}</td>
                    <td className={"py-3"}>{$patientGroupRow(campaign)}</td>
                    <td className={"py-3"}>{$createByRow(campaign)}</td>
                    <td className={"py-3"}>{$statisticsRow(campaign)}</td>
                    <td className={"py-3"}>{$menuRow(campaign)}</td>
                </tr>
            )
        })
    }

    const $noArchivedCampaign = (
        <p className={"text-gray-1 text-sm my-2"}>No archived campaign yet.</p>
    )
    const $archivedCampaignContent = () => {
        if (isNoActiveRecord) {
            return $noArchivedCampaign
        }
        return $tableRowsFor(dataSource)
    }
    const $activeCampaignContent = () => {
        const appointCampaigns = dataSource.filter((campaign) => campaign.summary.automatedCampaignType === AutomatedCampaignType.appointment)
        const birthdayCampaigns = dataSource.filter((campaign) => campaign.summary.automatedCampaignType === AutomatedCampaignType.birthday)
        const otherCampaigns = dataSource.filter((campaign) => campaign.summary.automatedCampaignType !== AutomatedCampaignType.appointment && campaign.summary.automatedCampaignType !== AutomatedCampaignType.birthday)
        const hasMultipleTypes = [appointCampaigns.length, birthdayCampaigns.length, otherCampaigns.length].filter((len) => len > 0).length >= 2
        if (hasMultipleTypes) {
            return (
                <Fragment>
                    {$tableSectionHeader("Appointment Reminder", appointCampaigns.length, isAppointmentSectionCollapsed, () => {
                        setIsAppointmentSectionCollapsed(!isAppointmentSectionCollapsed)
                    })}
                    {isAppointmentSectionCollapsed ? null : $tableRowsFor(appointCampaigns)}
                    {$tableSectionHeader("Birthday Reminder", birthdayCampaigns.length, isBirthdaySectionCollapsed, () => {
                        setIsBirthdaySectionCollapsed(!isBirthdaySectionCollapsed)
                    })}
                    {isBirthdaySectionCollapsed ? null : $tableRowsFor(birthdayCampaigns)}
                    {$tableSectionHeader("Others", otherCampaigns.length, isOtherSectionCollapsed, () => {
                        setIsOtherSectionCollapsed(!isOtherSectionCollapsed)
                    })}
                    {isOtherSectionCollapsed ? null : $tableRowsFor(otherCampaigns)}
                </Fragment>
            )
        }
        return $tableRowsFor(dataSource)
    }

    const $tableHeader = (<tr className={"text-left text-gray-2 font-semibold border-b border-base-border"}>
        <th className={"pb-4 text-sm"}>Campaign Name</th>
        <th className={"pb-4 text-sm"}>Status</th>
        <th className={"pb-4 text-sm"}>Type</th>
        <th className={"pb-4 text-sm"}>Patient Group</th>
        <th className={"pb-4 text-sm"}>Created By</th>
        <th className={"pb-4 text-sm"}>Statistics</th>
        <th className={"pb-4 text-sm"} />
    </tr>)

    const $table = (
        <div className={`w-full mt-4 p-6 flex flex-col items-center bg-white rounded ${isNoActiveRecord ? "shadow-md" : ""}`}>
            <table className={"w-full"}>
                <thead>
                    {$tableHeader}
                </thead>
                <tbody>
                    {campaignListType === CampaignListType.active ? $activeCampaignContent() : $archivedCampaignContent()}
                </tbody>
            </table>
            {/*{$tableFooter}*/}
        </div>
    )

    const $campaignPreviewModal = () => {
        if (!selectedCampaign) {
            return null
        }

        return (
            <CustomModal containerClassName={"w-192 p-0"} isOpen={showCampaignPreviewModal}>
                <PreviewCampaign
                    presentationStyle={PresentationStyle.modal}
                    actionType={ActionType.view}
                    setting={selectedCampaign.detail.setting}
                    dataForTemplateLanguage={selectedCampaign.detail.templateContentList}
                    onBack={() => {
                        setShowCampaignPreviewModal(false)
                    }}
                />
            </CustomModal>
        )
    }

    const $campaignStatisticModal = () => {
        if (!selectedCampaign) {
            return null
        }

        const {summary} = selectedCampaign
        const {id, relationId, campaignBigType, name, sendDateTime, patientCount, sendSuccessCount, sendFailedCount, toBeSentCount} = summary
        const fileName = `${name}-${sendDateTime}.csv`

        return (
            <CustomModal isOpen={showCampaignStatisticModal}>
                <CampaignStatisticList
                    campaignBigType={campaignBigType}
                    fileName={fileName}
                    campaignId={id}
                    relationId={relationId}
                    patientCount={patientCount}
                    sendSuccessCount={sendSuccessCount}
                    sendFailedCount={sendFailedCount}
                    tobeSentCount={toBeSentCount}
                    onBack={() => {
                        setShowCampaignStatisticModal(false)
                    }}
                />
            </CustomModal>
        )
    }

    const $emptyCampaign = (
        <div className={"w-full mt-4"}>
            <EmptyCampaign onClick={onNewCampaign} />
        </div>
    )

    const $spinner = (<Spinner isOpen={isShowSpinner} />)

    return (
        <div className={"min-w-min"}>
            {(!isShowSpinner && isNoActiveRecord && campaignListType === CampaignListType.active) ? $emptyCampaign : $table}
            {$campaignPreviewModal()}
            {$campaignStatisticModal()}
            {$spinner}
        </div>
    )
}
